import * as React from "react";
import { useSelector } from "react-redux";

import { Box, Typography, Divider } from "@mui/material";

import RedirectButton from "../../../ui-components/Buttons/RedirectButton";

export default function MobileStart() {
	const clientState = useSelector((state) => state.client || {});
	return (
		<React.Fragment>
			<Box
				sx={{
					bgcolor: "white",
					height: "100%",
					width: { xs: "100%", sm: "calc(100% - 4px)" },
					p: 3,
					overflow: "auto",
					borderRadius: "18px 18px 0px 0px",
				}}
			>
				<Typography
					variant="h5_bold"
					sx={{
						display: "flex",
						justifyContent: "center",
						mt: 1,
						color: "#06b6ad",
					}}
				>
					Welcome to the
				</Typography>
				<Typography
					variant="h3_bold"
					sx={{
						display: "flex",
						justifyContent: "center",
						mt: 1,
						color: "#06b6ad",
						textAlign: "center",
					}}
				>
					Language, Literacy & Numeracy Quiz
				</Typography>
				{clientState?.details?.displayName && (
					<>
						<Typography
							variant="h5_bold"
							sx={{
								display: "flex",
								justifyContent: "center",
								mt: 1,
								color: "#06b6ad",
								textAlign: "center",
							}}
						>
							for
						</Typography>
						<Typography
							variant="h4_bold"
							sx={{
								display: "flex",
								justifyContent: "center",
								color: "#06b6ad",
								textAlign: "center",
							}}
						>
							{clientState?.details?.displayName}
						</Typography>
					</>
				)}
				<Divider sx={{ my: 3 }} />
				{/* <Typography
					variant="tlrg_footer"
					sx={{
						textAlign: "center",
						display: "flex",
						justifyContent: "center",
						mb: 5,
					}}
				>
					The Learning Resources Group
				</Typography> */}
				<RedirectButton url="/info" title="START" />
			</Box>
		</React.Fragment>
	);
}